import React from 'react';
import styled from 'styled-components';
import HomeBg from 'assets/home-bg.png';
import { Box, Image, Flex, Text } from 'atoms';
import { LoginForm } from 'components';
import RipplrLogoWhite from 'assets/LogiTrack_logo.svg';

export const Container = styled(Flex)`
	overflow: hidden;
`;

export const ImgContainer = styled(Box)`
	width: 50%;
	height: 100vh;
`;

export const FormContainer = styled(Flex)`
	width: 50%;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: #fff;
`;

export const Title = styled(Text)`
	font-size: 46px;
	font-weight: 600;
	line-height: 50px;
	color: ${(props) => props.theme.colors.black};
`;

export const SubTitle = styled(Text)`
	font-size: 16px;
	line-height: 21px;
	margin: 1.5rem 0px 2.5rem 0px;
	color: #858585;
	text-align: center;
`;

export const Img = styled(Image)`
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

export default function Login() {
	return (
		<Container>
			<ImgContainer>
				<Img src={HomeBg} alt="Home Bg image" />
			</ImgContainer>
			<FormContainer>
				<Image width={156} height={101} src={RipplrLogoWhite} alt="home" />
				<Title>Welcome Back</Title>
				<SubTitle>Please Login to your Account</SubTitle>
				<LoginForm />
			</FormContainer>
		</Container>
	);
}
